import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Modal,
} from "@material-ui/core";
import { Clock, PaintBrush, PaperPlaneTilt } from "phosphor-react";
import useStyles from "./CommentBox.styles";
import PostEditor from "../../PostEditor/postEditor";
import { fpost, fpostBFF } from "../../../API/callsAPI";
import { MovieColabContext } from "../../../Context/MovieColabContext";
import CanvasFrame from "../../CanvasFrame/CanvasFrame.component";

const CommentBox = ({
  currentTime,
  selectedVersion,
  setRefreshCounter,
  refreshCounter,
  projectId,
  setScreenshot,
  screenshot,
  canvasModal,
  setCanvasModal,
}) => {
  const classes = useStyles();
  let mentionsRef = React.createRef();
  const [attachmentImage, setAttachmentImage] = useState(null);
  const [resetCommentText, setResetCommentText] = useState(0);
  const [addingComment, setAddingComment] = useState(false);
  const [allUsersName, setAllUsersName] = useState([]);
  const { trackableClass } = useContext(MovieColabContext);
  const [isTimeStampChecked, setIsTimeStampChecked] = useState(false);

  async function fetchShotVersion() {
    const shotversion = {
      url: "web/shotversion/list/",
      data: {
        project_id: projectId,
        shot_id: selectedVersion.shotVersion.shot.id,
      },
    };
    try {
      const res = await fpostBFF(shotversion);

      setAllUsersName(
        res.data.project_users.results.map((el) => {
          const data = {
            name: el.first_name + " " + el.last_name,
            id: el.id,
          };
          return data;
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchShotVersion();
  }, []);

  const getTimeStamp = () => {
    return currentTime !== "00:00" && currentTime > 0 && selectedVersion?.previousEnd
      ? currentTime - Math.floor(selectedVersion.previousEnd)
      : "";
  };

  const formatTimeToMMSS = (timeInSeconds) => {
    if (!timeInSeconds || timeInSeconds < 0) return "00:00";
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };
  let shotVersionClass = trackableClass?.find(
    (el) => el.model === "shotversion"
  );

  const handleSubmit = async ({
    description,
    mentions,
    repliedTo,
    attachmentImage,
    timestamp,
  }) => {
    if (!mentionsRef.current.toHtml()) {
      return;
    }
    setAddingComment(true);
    const formData = new FormData();
    formData.append("description", description);
    formData.append("trackable", selectedVersion.shot);
    formData.append("version_id", selectedVersion?.shotVersion.id);
    formData.append("version_type", shotVersionClass ? shotVersionClass.id : 0);
    if (isTimeStampChecked) {
      formData.append("timestamp", timestamp || 0);
    }

    mentions.forEach((mention) => {
      formData.append(`mentions`, mention);
    });

    if (repliedTo) formData.append("replied_to", repliedTo.id);

    if (attachmentImage) {
      const blob = await fetch(attachmentImage).then((res) => res.blob());
      const file = new File([blob], "img.jpg", { type: "image/jpg" });
      formData.append("attachment", file);
    }
    // mentionsRef.current.reset();
    let newComment = {
      url: "trackables/trackable-comment/",
      data: formData,
    };
    try {
      await fpost(newComment);
      return newComment;
    } catch (error) {
      console.log(error);
      return error;
    }
    setAddingComment(false);
  };

  const addNewComment = async () => {
    try {
      const newCommentRes = await handleSubmit({
        description: isTimeStampChecked
          ? getTimeStamp() + mentionsRef.current.toHtml()
          : mentionsRef.current.toHtml(),
        mentions: mentionsRef.current.onExtractMentions(),
        attachmentImage: attachmentImage,
        timestamp: getTimeStamp(),
      });
      setAttachmentImage(null);
      if (newCommentRes) {
        mentionsRef.current?.reset();
        setResetCommentText(resetCommentText + 1);
        setRefreshCounter(refreshCounter + 1);
        setAddingComment(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
        gap: "8px",
      }}
    >
      <Box
        sx={{
          width: "calc(100% - 44px)",
          height: "100%",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            height: "27px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              bgcolor: "#1B1D28",
              borderRadius: "3px",
              padding: " 4px 6px",
              width: "fit-content",
              boxSizing: "border-box",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Clock size={14} />
              <span>
                {selectedVersion?.previousEnd && formatTimeToMMSS(
                  currentTime - Math.floor(selectedVersion.previousEnd)
                )}
              </span>
            </div>
            <Checkbox
              checked={isTimeStampChecked}
              size="small"
              onClick={() => setIsTimeStampChecked(!isTimeStampChecked)}
              style={{
                padding: "0px",
              }}
            />
          </Box>
          <Button
            size="small"
            onClick={() => setCanvasModal(!canvasModal)}
          >
            <PaintBrush size={22} />
          </Button>
        </Box>
        <div
          style={{
            height: "calc(100% - 27px)",
            width: "100%",
            overflow: "auto",
            marginTop: "5px",
          }}
        >
          <PostEditor
            placeholder={"Type a Comment..."}
            mentions={allUsersName}
            ref={mentionsRef}
            handleAddImageAttachment={(image) => setAttachmentImage(image)}
            handleFilePaste={(file) => {
              setAttachmentImage(URL.createObjectURL(file[0]));
            }}
            handleSubmit={() => {
              addNewComment();
            }}
            resetPrevious={resetCommentText}
          />
        </div>
      </Box>
      <Box>
        <Button
          className={classes.submitButton}
          onClick={() => {
            addNewComment();
          }}
        >
          {addingComment ? (
            <CircularProgress size={20} />
          ) : (
            <PaperPlaneTilt size={22} />
          )}
        </Button>
      </Box>
      <Modal
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        open={canvasModal}
      >
        <CanvasFrame
          imageRef={null} //state
          image={screenshot} //state
          assetID={selectedVersion?.shot}
          toggle={() => setCanvasModal(!canvasModal)} //state
          fetchComments={() => setRefreshCounter(refreshCounter + 1)} //function
          version_id={selectedVersion?.shotVersion?.id}
          version_type={shotVersionClass ? shotVersionClass.id : 0}
          users={allUsersName}
          progress={getTimeStamp()} //current time
          closeModal={() => setCanvasModal(false)}
          updateCommentsRefreshCounter={() =>
            setRefreshCounter((prev) => prev + 1)
          }
        />
      </Modal>
    </Box>
  );
};

export default CommentBox;
